import { render, staticRenderFns } from "./produkdeposito.vue?vue&type=template&id=09724cda&scoped=true&"
import script from "./produkdeposito.vue?vue&type=script&lang=js&"
export * from "./produkdeposito.vue?vue&type=script&lang=js&"
import style0 from "./produkdeposito.vue?vue&type=style&index=0&id=09724cda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09724cda",
  null
  
)

export default component.exports